import Shuffle from 'shufflejs';

export function filters() {
  const wrappers = Array.from(document.querySelectorAll('[data-filters-wrapper]'));
  for (const wrapper of wrappers) {
    initFilters(wrapper);
  }
}

function initFilters(wrapper) {
  const grid = wrapper.querySelector('[data-filter-grid]');

  const shuffle = new Shuffle(grid, {
    itemSelector: '[data-filter-item]',
    sizer: wrapper.querySelector('[data-filter-sizer]'),
  });

  const inputs = Array.from(wrapper.querySelectorAll('[data-filter]'));

  for (const input of inputs) {
    input.addEventListener('change', doFilter);
  }

  function doFilter() {
    const state = getState();

    shuffle.filter((element) => {
      const types = JSON.parse(element.dataset.type);
      const typeMatches = !state.type || types.includes(Number(state.type));
      const campuses = JSON.parse(element.dataset.campus);
      const campusMatches = !state.campus || campuses.includes(Number(state.campus));

      return typeMatches && campusMatches;
    });
  }

  function getState() {
    const state = {};
    for (const input of inputs) {
      state[input.name] = input.value;
    }
    return state;
  }
}
